import * as React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { IoIosCloseCircleOutline } from "react-icons/io";
import CloseButton from "src/Assets/images/CloseButton.svg";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  borderRadius: 2, // ✅ smooth corners
  outline: "none", // ✅ removes focus outline
};

export default function EmailActionModel({ open, handleClose, message }) {
  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="email-action-modal"
    >
      <Box sx={style}>
        <div>
          <button
            onClick={handleClose}
            style={{
              position: "absolute",
              top: 10,
              right: 10,
              backgroundColor: "transparent",
              border: "none",
              outline: "none",
              cursor: "pointer",
              padding: 0,
            }}
          >
            <img src={CloseButton} alt="close" />
          </button>
        </div>

        {/* ✅ Message */}
        <Typography sx={{ mt: 2, textAlign: "center" }}>{message}</Typography>
      </Box>
    </Modal>
  );
}
